import React from "react";
import {
  FaShieldAlt,
  FaUniversalAccess,
  FaBolt,
  FaLock,
} from "react-icons/fa";

const TRUST_SEALS = [
  {
    icon: <FaShieldAlt />,
    title: "Banco Central",
    text: "Regulado e supervisionado",
  },
  {
    icon: <FaLock />,
    title: "LGPD",
    text: "Privacidade ponta a ponta",
  },
  {
    icon: <FaBolt />,
    title: "Pix 24/7",
    text: "Gratuito e instantâneo",
  },
  {
    icon: <FaUniversalAccess />,
    title: "Open Finance",
    text: "Conexão segura com seus dados",
  },
];

export const Features = (props) => {
  return (
    <header id="header">
      <div className="intro2">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-md-offset-1 col-xs-12 intro2-text">
                <h1 className="intro2-title">
                  {props.data
                    ? props.data.title
                    : "Banking digital, do jeito que o seu dia pede"}
                </h1>
                <p className="intro2-subtitle">
                  Tecnologia, transparência e segurança — pensados para
                  descomplicar a sua relação com o dinheiro.
                </p>

                <ul className="trust-seals" aria-label="Segurança e regulação">
                  {TRUST_SEALS.map((seal, idx) => (
                    <li key={idx} className="trust-seal">
                      <span className="trust-seal-icon" aria-hidden="true">
                        {seal.icon}
                      </span>
                      <div className="trust-seal-text">
                        <strong>{seal.title}</strong>
                        <span>{seal.text}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
